import { render, staticRenderFns } from "./CreateWithdrawal.vue?vue&type=template&id=45a71bbc&scoped=true"
import script from "./CreateWithdrawal.vue?vue&type=script&scoped=true&lang=js"
export * from "./CreateWithdrawal.vue?vue&type=script&scoped=true&lang=js"
import style0 from "./CreateWithdrawal.vue?vue&type=style&index=0&id=45a71bbc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45a71bbc",
  null
  
)

export default component.exports